// Lingala translations
export const ln: Record<string, string> = {
  'menu.dashboard': 'Dashboard',
  'menu.customers': 'Bakiliya',
  'menu.products': 'Biloko',
  'menu.users': 'Bansaleli',
  'menu.settings': 'Ba paramètres',
  'menu.logout': 'Kobima',
  'dashboard.title': 'Dashboard',
  'dashboard.newOrder': 'Komanda ya sika',
  'order.title': 'Komanda ya sika',
  'order.customer': 'Mokiliya',
  'order.products': 'Biloko',
  'order.total': 'Nionso',
  'users.title': 'Bansaleli',
  'users.name': 'Nkombo',
  'users.email': 'Email',
  'common.yes': 'Ée',
  'common.no': 'Te',
  'common.cancel': 'Koboya',
  'common.save': 'Kobomba',
  'common.search': 'Koluka',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Kokɔta',
  'login.welcome': 'Boyei malamu, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Email',
  'signup.phone': 'Telefone',
};